(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mixwith"));
	else if(typeof define === 'function' && define.amd)
		define("javel", ["mixwith"], factory);
	else if(typeof exports === 'object')
		exports["javel"] = factory(require("mixwith"));
	else
		root["javel"] = factory(root["mixwith"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 